import React, { useId } from 'react';

const VB = 64;
const CX = VB / 2;
const CY = VB / 2;

/**
 * Static bot mark: filled disc with radial slots and center knockout (negative space),
 * echoing ChatbotLogo (circle + radiating lines + center square).
 */
export function BesperBotProductMarkGroup({ iconColor = '#022d54' }) {
  const uid = useId().replace(/:/g, '');
  const maskId = `besperBotMask-${uid}`;

  const numLines = 12;
  const lines = [];
  for (let i = 0; i <= numLines; i += 1) {
    const t = i / numLines;
    const startX = t * VB;
    const startY = VB - 2;
    const waveOffset = Math.sin(t * Math.PI * 2) * 5;
    const endX = startX * 0.15 + waveOffset * 0.4 + CX * 0.85 - 16 + t * 32;
    const endY = CY - 4 + (1 - t) * 8;
    lines.push(
      <line
        key={`rl-${i}`}
        x1={startX}
        y1={startY}
        x2={endX}
        y2={endY}
        stroke="black"
        strokeWidth={3.2}
        strokeLinecap="round"
      />,
    );
  }

  const sq = 11;
  const sx = CX - sq / 2;
  const sy = CY - sq / 2;

  return (
    <g>
      <defs>
        <mask id={maskId}>
          <circle cx={CX} cy={CY} r={25.5} fill="white" />
          <g stroke="black" fill="black">
            {lines}
            <rect x={sx} y={sy} width={sq} height={sq} rx={1.2} />
          </g>
        </mask>
      </defs>
      <circle cx={CX} cy={CY} r={25.5} fill={iconColor} mask={`url(#${maskId})`} />
      <circle cx={CX} cy={CY} r={27} fill="none" stroke={iconColor} strokeWidth={2} opacity={0.35} />
    </g>
  );
}

export function BesperBotProductMark({ size = 64, className = '', iconColor = '#022d54' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${VB} ${VB}`}
      className={className}
      aria-hidden
    >
      <BesperBotProductMarkGroup iconColor={iconColor} />
    </svg>
  );
}
